function findItems(sourceData: any[], fieldsInludes: any): any {
    return sourceData.filter((field: any) => fieldsInludes.includes(field));
}


function findContentFields(item: object | [], dateFields: any) {
    return Array.isArray(item) ? findItems(item, dateFields) : findItems(Object.keys(item), dateFields);
}

export default findContentFields;